import { render, staticRenderFns } from "./xiaofei.vue?vue&type=template&id=597234a7&scoped=true"
import script from "./xiaofei.vue?vue&type=script&lang=js"
export * from "./xiaofei.vue?vue&type=script&lang=js"
import style0 from "./xiaofei.vue?vue&type=style&index=0&id=597234a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597234a7",
  null
  
)

export default component.exports